import React, { useEffect, useState } from 'react'
import "../../Assets/Css/Tickets.scss"
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { IoClose, IoCloudUploadOutline } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from "react-select";
import { customStyle } from '../../Components/Style';
import { Accordion } from 'react-bootstrap';
import Pdf from '../../Assets/Images/Employee/Pdf.svg'
import { addTicket, updateTicket } from '../../Services/Ticket/action';
import { getClients } from '../../Services/Clients/action';
import { getUsers } from '../../Services/Users/action';
import { connect } from 'react-redux';


const priority = [
     { value: 'Urgent', label: 'Urgent' },
     { value: 'High', label: 'High' },
     { value: 'Medium', label: 'Medium' },
     { value: 'Low', label: 'Low' },
]

const channelName = [
     { value: 'Email', label: 'Email' },
     { value: 'Phone', label: 'Phone' },
     { value: 'Twitter', label: 'Twitter' },
     { value: 'Facebook', label: 'Facebook' },
]

const type = [
     { value: 'Suggestion', label: 'Suggestion' },
     { value: 'Question', label: 'Question' },
     { value: 'Sale', label: 'Sale' },
     { value: 'Code', label: 'Code' },
     { value: 'Problem', label: 'Problem' },
     { value: 'Incident', label: 'Incident' },
     { value: 'Management', label: 'Management' },
]

const agent = [

]

const CreateTicket = (props) => {
     const [files, setFiles] = useState([]);
     const [previews, setPreviews] = useState([]);
     const location = useLocation();
     const data = location?.state?.data?.allData;
     const navigate = useNavigate();

     useEffect(() => {
          props?.getUsers({ module: 'users-names' });
          props?.getClients("");
     }, [])

     const [Fields, setFields] = useState({
          client: "",
          employee: "",
          requestername: null,
          ticketsubject: "",
          notes: "",
          tags: "",
          priority: null,
          channelname: null,
          type: null,
          agent: ""
     });

     useEffect(() => {
          if ((props?.clients?.length > 0 || props?.users?.length > 0) && (data?.client_id || data?.employee_id)) {
               const requestername = (Fields?.client ? props?.clients : props?.users)?.map(item => ({
                    value: item.id,
                    label: item.name,
               }));
               const matchedName = requestername?.find(item => item?.value == (data?.user_id || data?.client_id));
               if (matchedName) {
                    setFields(prev => ({
                         ...prev,
                         requestername: matchedName,
                    }));
               }
          }
     }, [props?.clients, props?.users, data?.client_id]);

     const handleFileChange = (event) => {
          setFiles([]);
          setPreviews([]);

          const newFiles = Array.from(event.target.files);
          const newPreviews = newFiles.map(file => URL.createObjectURL(file));

          setPreviews(prevPreviews => [...prevPreviews, ...newPreviews]);
          setFiles(prevFiles => [...prevFiles, ...newFiles]);
     };

     const fileToBase64 = (file) => {
          return new Promise((resolve, reject) => {
               const reader = new FileReader();
               reader.readAsDataURL(file);
               reader.onload = () => resolve(reader.result);
               reader.onerror = (error) => reject(error);
          });
     };

     const handleSave = async () => {
          try {
               const file = files[0];
               const base64File = await fileToBase64(file);
               const body = {
                    client_id: Fields?.client ? props?.clients?.find(client => client?.name == Fields?.requestername?.label)?.id : null,
                    employee_id: Fields?.employee ? props?.users?.find(user => user?.name == Fields?.requestername?.label)?.id : null,
                    subject: Fields?.ticketsubject,
                    description: Fields?.notes,
                    file: base64File,
                    agent: Fields?.agent,
                    priority: Fields?.priority?.value,
                    type: Fields?.type?.value,
                    channel_name: Fields?.channelname?.value,
                    date: new Date(),
                    tags: Fields.tags,
               }
               if (data) {
                    await props?.updateTicket(data?.id, body)
               }
               else {
                    await props?.addTicket({ ...body, status: "Pending" })
               }
               navigate(-1)
          } catch (error) {
               console.error("Error creating Ticket: ", error)
          }
     }
     return (
          <div className='ticket-container mb-5'>
               <div className="page-title">
                    <h4>Create Ticket</h4>
                    <div className="edit-btn">
                         <button
                              type="submit"
                              className="custom-btn"
                              onClick={() => navigate(-1)}
                         >Cancel</button>

                         <button
                              type="submit"
                              className="custom-btn"
                              onClick={handleSave}
                         >
                              {/* {props.loading ? (
                                        <Spinner
                                             as="span"
                                             animation="border"
                                             className="custom-spinner"
                                             role="status"
                                             aria-hidden="true"
                                        />
                                        ) : ( */}
                              Save
                              {/* )} */}
                         </button>
                    </div>
               </div>

               <div className='row parent-filter m-0 pt-4 pb-5 h-auto mb-4'>
                    <div className="col-lg-3 col-md-3 col-sm-12">
                         <div className='input-group'>
                              <div>
                                   <label className='label'>Requester</label>
                              </div>
                              <div className='attandance_radio_grp'>
                                   <div className="radiobtn">
                                        <input
                                             type="radio"
                                             name='attendance'
                                             value='client'
                                             checked={Fields.client}
                                             onChange={(data) => {
                                                  setFields({
                                                       ...Fields,
                                                       client: true,
                                                       employee: false,
                                                       requestername: ""
                                                  })
                                             }}
                                        />
                                        <lable className="label">Client</lable>
                                   </div>
                                   <div className="radiobtn ms-3">
                                        <input
                                             type="radio"
                                             name='attendance'
                                             value='employee'
                                             checked={Fields.employee}
                                             onChange={(data) => {
                                                  setFields({
                                                       ...Fields,
                                                       client: false,
                                                       employee: true,
                                                       requestername: ""
                                                  })
                                             }}
                                        />
                                        <lable className="label">Employee</lable>
                                   </div>
                              </div>
                         </div>
                    </div>


                    <div className="col-lg-4 col-md-4 col-sm-12">
                         <div className='input-group'>
                              <label className='label'>Requester Name *</label>
                              <Select
                                   value={Fields.requestername}
                                   onChange={(data) =>
                                        setFields({
                                             ...Fields,
                                             requestername: data,
                                        }
                                        )
                                   }
                                   options={Fields?.client ? props?.clients?.map(item => {
                                        return {
                                             value: item?.id,
                                             label: item?.name
                                        }
                                   }) : props?.users?.map(item => {
                                        return {
                                             value: item?.id,
                                             label: item?.name
                                        }
                                   })}
                                   placeholder={"--"}
                                   styles={customStyle}
                                   theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                             ...theme.colors,
                                             primary25: "#5757fe",
                                             primary: "#5757fe",
                                        },
                                   })}
                              />
                         </div>
                    </div>

                    <div className="col-lg-12 col-md-12 description ">
                         <div className='input-group'>
                              <label className='label'>Ticket Subject</label>
                              <input
                                   value={Fields.ticketsubject}
                                   onChange={(e) =>
                                        setFields({
                                             ...Fields,
                                             ticketsubject: e.target.value,
                                        }
                                        )
                                   }
                              />
                         </div>
                    </div>

                    <div className="col-lg-12 z-0 mb-3">
                         <div className="note-part">
                              <lable className='label'>Description</lable>
                              <div className="editor-custom">
                                   <CKEditor
                                        editor={ClassicEditor}
                                        data={Fields?.notes || ""}
                                        onReady={editor => {
                                             console.log('Editor is ready to use!', editor);
                                        }}
                                        onChange={(event, editor) => {
                                             const data = editor.getData();
                                             setFields({
                                                  ...Fields,
                                                  notes: data,
                                             })
                                        }}
                                        onBlur={(event, editor) => {
                                             console.log('Blur.', editor);
                                        }}
                                        onFocus={(event, editor) => {
                                             console.log('Focus.', editor);
                                        }}
                                   />
                              </div>
                         </div>
                    </div>

                    <div className="col-lg-12 col-md-12  ">
                         <form action="">
                              <div className="form-group">
                                   <div className="input-group">
                                        <label className="label">Upload files</label>
                                        <div className="file-upload-wrapper">
                                             <label htmlFor="file-upload" className="file-upload-label">
                                                  <IoCloudUploadOutline />
                                                  <p>Choose files</p>
                                             </label>
                                             <input
                                                  type="file"
                                                  id="file-upload"
                                                  className="file-upload-input"
                                                  name="photos"
                                                  multiple
                                                  onChange={handleFileChange}
                                             />
                                        </div>
                                   </div>
                              </div>
                         </form>
                    </div>

                    {previews.length > 0 && (
                         <div className="preview">
                              {previews.map((preview, index) => (
                                   <div key={index} className="preview-item">
                                        {files[index].type.startsWith('application/pdf') ? (
                                             <div className='preview-pdf'>
                                                  <div style={{ display: 'flex' }}>
                                                       <img src={Pdf} alt="" style={{ width: "100px", height: "100px" }} />
                                                       <div className="remove-pdf-icon" onClick={() => handleRemoveFile(index)}>
                                                            <IoClose />
                                                       </div>
                                                  </div>
                                                  <div className='preview-text mt-2'>
                                                       <span className='text-center '>
                                                            {files[index].name}
                                                       </span>
                                                  </div>
                                             </div>
                                        ) : (
                                             <div className="preview-image-wrapper">
                                                  <img src={preview} alt={`File preview ${index}`} className="preview-image" />
                                                  <div className="remove-icon" onClick={() => handleRemoveFile(index)}>
                                                       <IoClose />
                                                  </div>
                                                  <div className='preview-text mt-2'>
                                                       <span className='text-center '>
                                                            {files[index].name}
                                                       </span>
                                                  </div>
                                             </div>
                                        )}

                                   </div>
                              ))}
                         </div>
                    )}
               </div>

               <div className="parent-filter mt-4 mb-5">
                    <Accordion defaultActiveKey={0}>
                         <Accordion.Item eventKey="0">
                              <Accordion.Header>Other Details</Accordion.Header>
                              <Accordion.Body>
                                   <div className="row">
                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                             <div className="card-type">
                                                  <label className="labeling task-catagory">
                                                       <div className='input-group'>
                                                            <lable className='label'>Agent</lable>
                                                            <Select
                                                                 value={Fields.agent}
                                                                 onChange={(data) =>
                                                                      setFields({
                                                                           ...Fields,
                                                                           agent: data,
                                                                      }
                                                                      )
                                                                 }
                                                                 options={agent}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </label>
                                             </div>
                                        </div>

                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                             <div className="card-type">
                                                  <label className="labeling task-catagory">
                                                       <div className='input-group'>
                                                            <lable className='label'>Priority</lable>
                                                            <Select
                                                                 value={Fields.priority}
                                                                 onChange={(data) =>
                                                                      setFields({
                                                                           ...Fields,
                                                                           priority: data,
                                                                      }
                                                                      )
                                                                 }
                                                                 options={priority}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </label>
                                             </div>
                                        </div>

                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                             <div className="card-type">
                                                  <label className="labeling">
                                                       <div className='input-group'>
                                                            <lable className='label'>Type</lable>
                                                            <Select
                                                                 value={Fields.type}
                                                                 onChange={(data) =>
                                                                      setFields({
                                                                           ...Fields,
                                                                           type: data,
                                                                      }
                                                                      )
                                                                 }
                                                                 options={type}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </label>
                                             </div>
                                        </div>

                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                             <div className="card-type">
                                                  <label className="labeling">
                                                       <div className='input-group'>
                                                            <lable className='label'>Channel Name</lable>
                                                            <Select
                                                                 value={Fields.channelname}
                                                                 onChange={(data) =>
                                                                      setFields({
                                                                           ...Fields,
                                                                           channelname: data,
                                                                      }
                                                                      )
                                                                 }
                                                                 options={channelName}
                                                                 placeholder={"--"}
                                                                 styles={customStyle}
                                                                 theme={(theme) => ({
                                                                      ...theme,
                                                                      colors: {
                                                                           ...theme.colors,
                                                                           primary25: "#5757fe",
                                                                           primary: "#5757fe",
                                                                      },
                                                                 })}
                                                            />
                                                       </div>
                                                  </label>
                                             </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12 description ">
                                             <div className='input-group'>
                                                  <label className='label'>Tags</label>
                                                  <input
                                                       value={Fields.tags}
                                                       onChange={(e) =>
                                                            setFields({
                                                                 ...Fields,
                                                                 tags: e.target.value,
                                                            }
                                                            )
                                                       }
                                                  />
                                             </div>
                                        </div>

                                   </div>
                              </Accordion.Body>
                         </Accordion.Item>
                    </Accordion>
               </div>
          </div>
     )
}

const mapStateToProps = (state) => {
     return {
          loading: state.ticketReducer.loading,
          clients: state.clientsReducer.clients.rows,
          users: state.userReducer.users
     };
}

const mapDispatchToProps = (dispatch) => {
     return {
          addTicket: (data) => {
               dispatch(addTicket(data))
          },
          updateTicket: (id, data) => {
               dispatch(updateTicket(id, data))
          },
          getClients: () => {
               dispatch(getClients(""))
          },
          getUsers: (options) => {
               dispatch(getUsers(options))
          }
     };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateTicket)
